import { createSlice } from '@reduxjs/toolkit'
import { initialState, listReducers } from './listConstants'

const outgoingQuotationsSlice = createSlice({
    name: 'ui/outgoing-quotations',
    initialState,
    reducers: listReducers
})

export const outgoingQuotationsActions = outgoingQuotationsSlice.actions
export default outgoingQuotationsSlice.reducer
